import useClientesModel from '../../../../modelos/Clientes/modeloClientes';
import EditableField from '../../../../components/EditableFields';
import React, { useEffect, useState, useMemo } from 'react';
import WompiPagoWidget from '../Modulos/WompiPago';
import ModuloTesis from '../ModuloTesis';
import ModuloPagos from '../ModuloPagos';
import ModuloEntregas from '../ModuloEntregas';
import ModuloHistorial from '../../../../components/Historial/Historial';
import PreguntasComponent from '../../solicitudes/Modulos/Preguntas';
import AnalisisIA from '../../solicitudes/components/AnalisisIASolicitud';
import ModuloRevision from '../ModuloRevision';
import PlantillaDetalle from '../../../../components/PlantillaLayout/PlantillaDetalle';
import ZonaEntregas from '../Modulos/ZonaEntregas';
import { determinarColorInfo } from '../CalendarioWidget';
import FileViewerBien from '../../../../components/FileViewerBien';

const AdminViewServicio = ({
  servicio, 
  visibleTabs, 
  handleTabChange,
  activeTab,
  materiasOptions,
  isAdmin,
  handleSave,
  auxiliarBusqueda,
  tutoresOptions,
  entregarTrabajo,
  handleSaveTesis,
  solicitud,
  handleEnviarPregunta,
  usuario,
  formData,
  setFormData,
  busquedaClientesOptions,
}) => {

  //admin tabs
  const AdminGeneralTab = () => {
      return (
        <div className="space-y-8">
          {/* INFORMACIÓN GENERAL */}
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="px-6 py-4 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Información General 
              </h3>
            </div>

            

            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <EditableField
                  field="codigo"
                  label="Código"
                  value={servicio.codigo}
                  type="text"
                  isAdmin={false}
                />
                <EditableField
                  field="materia"
                  label="Materia"
                  value={servicio.materia}
                  options={materiasOptions}
                  type="react-select"
                  isAdmin={isAdmin}
                  onSave={handleSave}
                />
                <EditableField
                  field="fechasistema"
                  label="Fecha sistema"
                  value={servicio.fechasistema}
                  type="date"
                />
                <EditableField
                  field="cliente"
                  label="Número cliente"
                  value={servicio.cliente}
                  onInputChange={auxiliarBusqueda}
                  options={busquedaClientesOptions}
                  type="react-select"
                  isAdmin={isAdmin}
                  onSave={handleSave}
                />
                <EditableField
                  field="tutor"
                  label="Tutor (sistema de notificacion de cambios)"
                  //onInputChange={}
                  options={tutoresOptions}
                  onSave={handleSave}
                  value={servicio.tutor}
                  type="react-select"
                  isAdmin={isAdmin}
                />
                <EditableField
                  field="fechaentrega"
                  label="Fecha de entrega"
                  value={servicio.fechaentrega}
                  type="datetime"
                  isAdmin={isAdmin}
                  onSave={handleSave}
                />
                <EditableField
                  field="idsolicitud"
                  label="ID Solicitud"
                  value={servicio.idsolicitud}
                  type="number"
                />
                <EditableField
                  field="idcontable"
                  label="ID Contable"
                  value={servicio.idcontable}
                  type="number"
                />
                <EditableField
                  field="identificadorcodigo"
                  label="Identificador de código"
                  value={servicio.identificadorcodigo}
                  type="react-select"
                />

                <EditableField
                  field="notasContabilidad"
                  label="Notas de contabilidad"
                  value={servicio.notasContabilidad}
                  type="textarea"
                  onSave={handleSave}
                  isAdmin={isAdmin}
                />

              </div>
            </div>

          </div>

          {/* ZONA PARA ASESORIAS */}
          {servicio.identificadorcodigo == "A" && (
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="px-6 py-4 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Zona de Asesorias
              </h3>
            </div>

            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                <EditableField
                  field="ObjetoAsesoria.htmlLink"
                  label="card link"
                  value={servicio?.ObjetoAsesoria?.htmlLink}
                  type="text"
                  isAdmin={false}
                />

                <EditableField
                  field="ObjetoAsesoria.hangoutLink"
                  label="Link de google meet"
                  value={servicio?.ObjetoAsesoria?.hangoutLink}
                  type="text"
                  isAdmin={false}
                />

                <EditableField
                  field="ObjetoAsesoria.enlaceGrabacion"
                  label="Enlace de grabacion (ponga NO si no existe registro de grabacion)"
                  value={servicio?.ObjetoAsesoria?.enlaceGrabacion}
                  type="text"
                  isAdmin={true}
                  onSave={handleSave}
                />

              </div>
            </div>

            </div>
          )}
          
          {/* ZONA DE PAGOS */}
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="px-6 py-4 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
                Zona de Pagos
              </h3>
            </div>

            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                
                {/* PAGOS DE CLIENTE */}
                <div className="bg-blue-50 rounded-lg p-5 border border-blue-200">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="font-medium text-blue-900 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      Pagos Cliente
                    </h4>
                    <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                      {servicio.preciocobrado > 0 ? 'Activo' : 'Sin costo'}
                    </span>
                  </div>
                  
                  <div className="space-y-3">
                    <EditableField
                      field="preciocobrado"
                      label="Precio cobrado"
                      value={servicio.preciocobrado}
                      type="number"
                      isAdmin={isAdmin}
                      onSave={handleSave}
                    />
                    
                    <div className="bg-white rounded-md p-3">
                      <div className="flex justify-between items-center text-sm">
                        <span className="text-gray-600">Total pagado:</span>
                        <span className="font-medium text-green-600">
                          ${servicio.getSumaPagosClientes ? servicio.getSumaPagosClientes() : 0}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-sm mt-1">
                        <span className="text-gray-600">Pendiente:</span>
                        <span className={`font-medium ${
                          servicio.getSaldoPendienteCliente ? 
                            (servicio.getSaldoPendienteCliente() > 0 ? 'text-red-600' : 'text-green-600') 
                            : 'text-gray-500'
                        }`}>
                          ${servicio.getSaldoPendienteCliente()}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-sm mt-1">
                        <span className="text-gray-600">Balance neto:</span>
                        <span className="font-medium text-blue-600">
                          ${servicio.getSumaBalanceClientes ? servicio.getSumaBalanceClientes() : 0}
                        </span>
                      </div>
                    </div>

                  <div className="mt-2">
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div 
                        className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                        style={{
                          width: `${servicio.getPorcentajePagoCliente ? servicio.getPorcentajePagoCliente() : 0}%`
                        }}
                      ></div>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">
                      {servicio.getPorcentajePagoCliente ? servicio.getPorcentajePagoCliente() : 0}% pagado
                    </p>
                  </div>
                  </div>
                </div>

                {/* PAGOS DE TUTOR */}
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-200">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="font-medium text-amber-900 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                      Pagos Tutor
                    </h4>
                  </div>
                  
                  <div className="space-y-3">
                    <EditableField
                      field="preciotutor"
                      label="Precio tutor"
                      value={servicio.preciotutor}
                      type="number"
                      isAdmin={isAdmin}
                       onSave={handleSave}
                    />
                    
                    <div className="bg-white rounded-md p-3">
                      <div className="flex justify-between items-center text-sm">
                        <span className="text-gray-600">Estado:</span>
                        <span className={`font-medium ${
                          servicio.getSumaBalanceTutor() == servicio.preciotutor ? 'text-green-600' : 'text-red-600'
                        }`}>
                          {servicio.getSumaBalanceTutor() == servicio.preciotutor ? 'Completado' : 'Pendiente'}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-sm mt-1">
                        <span className="text-gray-600">Monto:</span>
                        <span className="font-medium">${servicio.preciotutor || 0}</span>
                      </div>
                    </div>
                    
                  </div>
                </div>

                {/* PAGOS DE REFERIDOS */}
                <div className="bg-purple-50 rounded-lg p-5 border border-purple-200">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="font-medium text-purple-900 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      Pagos Referidos {servicio.referidoPor} {servicio.gananciaReferido}
                    </h4>
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      servicio.pagoReferido > 0 ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-600'
                    }`}>
                      {servicio.pagoReferido > 0 ? 'Aplicable' : 'No aplica'}
                    </span>
                  </div>
                  
                  <div className="space-y-3">
                    {servicio.pagoReferido > 0 ? (
                      <>
                        <div className="bg-white rounded-md p-3">
                          <div className="flex justify-between items-center text-sm">
                            <span className="text-gray-600">Referido por:</span>
                            <span className="font-medium">{servicio.referidoPor || 'No especificado'}</span>
                          </div>
                          <div className="flex justify-between items-center text-sm mt-1">
                            <span className="text-gray-600">Monto:</span>
                            <span className="font-medium text-purple-600">${servicio.pagoReferido}</span>
                          </div>
                          <div className="flex justify-between items-center text-sm mt-1">
                            <span className="text-gray-600">Estado:</span>
                            <span className={`font-medium ${
                              servicio.referidoPagado ? 'text-green-600' : 'text-red-600'
                            }`}>
                              {servicio.referidoPagado ? 'Pagado' : 'Pendiente'}
                            </span>
                          </div>
                        </div>
                        
                        <button className={`w-full py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                          servicio.referidoPagado 
                            ? 'bg-green-100 text-green-800 cursor-not-allowed' 
                            : 'bg-purple-600 text-white hover:bg-purple-700'
                        }`}>
                          {servicio.referidoPagado ? 'Ya pagado' : 'Marcar como pagado'}
                        </button>
                      </>
                    ) : (
                      <div className="bg-white rounded-md p-3 text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto text-gray-400 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L5.636 5.636" />
                        </svg>
                        <p className="text-sm text-gray-500">No hay pagos de referidos para este servicio</p>
                      </div>
                    )}
                  </div>
                
                </div>
              </div>
            </div>

            {/* SECCIÓN DE PAGOS WOMPI */}
            {/* Calcular 1/2 de pago y 1 pago completo */}
            {/* Programacion de onSucces y programacion de registro de pagos */}
            <WompiPagoWidget 
              valor={servicio.getSaldoPendienteCliente()} 
              referencia={`SERVICIO_${servicio.codigo}_${Date.now()}`}
              onSuccess={(datosWompi) => {
                // Cuando Wompi aprueba, registramos en nuestra base de datos local
                //handleRegistrarPago(); 
              }}
              titulo={`pagar por wompi ${servicio.getSaldoPendienteCliente()} `}
            />
            
          </div>

          <AnalisisIA
            explicacion={servicio.generateCalificacionIA}
          />

        
          <ZonaEntregas
            servicio={servicio}
            entregarTrabajo={entregarTrabajo}
            handleSave={handleSave}
            formData={formData}
            setFormData={setFormData}
          />

          Esto esta aca temporalmente de prueba para ver si el raster funciona correctamente

          <FileViewerBien
            files={servicio.previewEntrega}
            titulo={"Avances de la tarea."}
            esVistaPrevia={true}
          />

        </div>
      );
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'general':
        return AdminGeneralTab();
      case 'tesis':
        return <ModuloTesis servicio={servicio} onGuardarCalendario={handleSaveTesis} solicitud={solicitud} onGuardarServicio={handleSave}/>;
      case 'pagos':
        return <ModuloPagos servicio={servicio}/>;
      case 'entregas':
        return <ModuloEntregas servicio={servicio} isAdmin={isAdmin}/>;
      case 'historial':
        return <ModuloHistorial historial={servicio.historial}  />;
      case 'preguntas':
        return <PreguntasComponent 
                      preguntas={servicio.preguntas}
                      usuarioActual={usuario}
                      isAdmin={isAdmin}
                      onEnviarPregunta={handleEnviarPregunta}
                      onResponderPregunta={handleEnviarPregunta}
                    />;
      case 'revision':
        return <ModuloRevision 
                    servicio={servicio} 
                    isAdmin={true}
                  />


    }
  }

  return(
     <PlantillaDetalle
      tabs={visibleTabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
      >
        {renderTabContent()}
      </PlantillaDetalle>
  );
}

export default AdminViewServicio
